(function () {
  var SECTION_SELECTOR = '.oddit-section-sticky-add-to-cart';
  var sectionState = new Map();

  function initSection(section) {
    var mainAddToCart = document.querySelector('[data-add-to-cart]:not(.oddit-section-sticky-add-to-cart__add-btn)');
    if (!mainAddToCart) {
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          section.classList.add('is-visible');
        } else {
          section.classList.remove('is-visible');
        }
      }
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(mainAddToCart);

    var state = {
      observer: observer,
      target: mainAddToCart
    };
    sectionState.set(section, state);

    section.addEventListener('click', handleAddToCart);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (state) {
      state.observer.unobserve(state.target);
      state.observer.disconnect();
      sectionState.delete(section);
    }
    section.removeEventListener('click', handleAddToCart);
  }

  function handleAddToCart(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || !window.OdditCartDrawer) return;

    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    var quantity = Number(btn.getAttribute('data-quantity')) || 1;
    btn.disabled = true;

    window.OdditCartDrawer.addToCart(variantId, quantity)
      .then(function () {
        window.OdditCartDrawer.open();
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();